import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';

/**
 * Definition for the compound `Menu.Header` component, renders content in
 * the top part of the Menu component above the children.
 */
var Header = function Header(_a) {
  var children = _a.children,
    otherProps = __rest(_a, ["children"]);
  return jsx("div", Object.assign({
    className: "cogs-v10 cogs-menu-header"
  }, otherProps, {
    children: children
  }));
};

export { Header as default };
